import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/(logged)": [7,[2]],
		"/(logged)/about.html": [8,[2]],
		"/(logged)/admin/order/list": [9,[2]],
		"/(logged)/admin/order/[id]": [10,[2]],
		"/(logged)/admin/report": [11,[2]],
		"/(logged)/admin/report/calculate_orders": [12,[2]],
		"/(logged)/constructor/order/list": [13,[2]],
		"/(logged)/constructor/order/[id]": [14,[2]],
		"/(logged)/constructor/product/list": [15,[2]],
		"/(unlogged)/login": [37,[6]],
		"/(logged)/order/create": [16,[2]],
		"/(logged)/order/edit/[id]": [17,[2]],
		"/(logged)/order/list": [18,[2]],
		"/(logged)/products/[id].html": [19,[2]],
		"/(logged)/purchasing/order/kp2": [21,[2]],
		"/(logged)/purchasing/order/kp": [20,[2]],
		"/(logged)/purchasing/order/list": [22,[2]],
		"/(logged)/purchasing/order/test_exel": [23,[2]],
		"/(logged)/purchasing/order/[id]": [24,[2]],
		"/(logged)/status_list.html": [25,[2]],
		"/(logged)/sverdle": [~26,[2]],
		"/(logged)/sverdle/how-to-play": [27,[2]],
		"/(logged)/task_develop": [29,[2,3]],
		"/(logged)/task_develop/create": [30,[2,3,4]],
		"/(logged)/task_develop/[id]": [31,[2,3,5]],
		"/(logged)/task": [28,[2]],
		"/(logged)/test_form": [32,[2]],
		"/(logged)/users": [33,[2]],
		"/(logged)/users/create": [34,[2]],
		"/(logged)/users/[id]": [35,[2]],
		"/(logged)/usertbl": [36,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';